import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SearchService } from './search.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { of } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  panelOpenState: boolean = false
  keyword: string = '';
  inputValue: string;

  body;

  news: boolean = false;
  artical: boolean = false;
  course: boolean = false;
  workshop: boolean = false;
  measure: boolean = false;
  research: boolean = false;

  free: boolean = false;
  not_free: boolean = false;
  review: string = '';
  course_time: string = '';
  locationUrl: string = window.location.origin;
  item = [];

  filterForm: FormGroup;
  searchForm: FormGroup;

  newsList;
  articalList;
  workshopList;
  courseList;
  measureList;
  researchList;

  newsListDisplay;
  articalListDisplay;
  workshopListDisplay;
  courseListDisplay;
  measureListDisplay;
  researchListDisplay;
  display;

  filteredOptions: string[] = [];
  options = [];
  suggestSearch = [];
  sortForm;
  select: string = '';

  collectionSize: number;
  page: number = 1;
  pageSize: number = 20;
  rows = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private searchService: SearchService,

  ) {
    this.filteredOptions = this.suggestSearch;
    this.filterForm = this.fb.group({
      selectRate: [''],
      selectPeriod: ['']
    });

    this.sortForm = this.fb.group({
      sort: ['']
    });

    this.searchForm = this.fb.group({
      input: ['', Validators.required]
    });
  }

  ngOnInit(): void {

    this.keyword = new URL(location.href).searchParams.get('keyword');

    let params = this.route.snapshot.paramMap;
    if (params.has('keyword')) {
      this.keyword = params.get('keyword');
    }
    this.inputValue = this.keyword;
    // // console.log(this.keyword);

    this.body = {
      search_text: this.keyword,
      filter: {
        type: {
          news: this.news,
          artical: this.artical,
          course: this.course,
          workshop: this.workshop,
          measure: this.measure,
          research: this.research,
        },
        price: {
          free: this.free,
          not_free: this.not_free
        },
        review: this.review,
        course_time: this.course_time
      }
    }

    this.searchService.getSearch(this.body).pipe(
      switchMap(res => {
        if (res.success) {
          console.log(res.result);
          this.newsList = res.result[0].news;
          this.articalList = res.result[1].artical;
          this.courseList = res.result[2].course;
          this.workshopList = res.result[3].workshop;
          this.measureList = res.result[4].measure;
          this.researchList = res.result[5].research;
          this.manageData();
          this.sortData();
        }
        else {
          alert('ดึงข้อมูลไม่สำเร็จ');
        }
        return this.searchService.getSuggestSearch().pipe(
          map(res => {
            this.suggestSearch = res.result;

            this.suggestSearch.forEach(element => {
              this.options.push(element.search_text);
            });
          })
        )
      }),
      catchError((err) => {
        // // console.log(err);
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();

  }

  search() {

    let rate = this.filterForm.value.selectRate
    let period = this.filterForm.value.selectPeriod

    this.body = {
      search_text: this.keyword,
      filter: {
        type: {
          news: this.news,
          artical: this.artical,
          course: this.course,
          workshop: this.workshop,
          measure: this.measure,
          research: this.research,
        },
        price: {
          free: this.free,
          not_free: this.not_free
        },
        review: rate,
        course_time: period
      }
    }

    this.getSearch(this.body);

  }

  searchClick() {

    let rate = this.filterForm.value.selectRate
    let period = this.filterForm.value.selectPeriod
    this.keyword = this.inputValue;

    this.body = {
      search_text: this.inputValue,
      filter: {
        type: {
          news: this.news,
          artical: this.artical,
          course: this.course,
          workshop: this.workshop,
          measure: this.measure,
          research: this.research,
        },
        price: {
          free: this.free,
          not_free: this.not_free
        },
        review: rate,
        course_time: period
      }
    }

    this.getSearch(this.body);

  }

  onChange(value: string): void {

    this.filteredOptions = this.options.filter(option => option.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.inputValue = value;
  }

  reset() {

    this.news = false;
    this.artical = false;
    this.course = false;
    this.workshop = false;
    this.measure = false;
    this.research = false;

    this.free = false;
    this.not_free = false;
    this.review = '';
    this.course_time = '';

    this.body = {
      search_text: this.keyword,
      filter: {
        type: {
          news: this.news,
          artical: this.artical,
          course: this.course,
          workshop: this.workshop,
          measure: this.measure,
          research: this.research,
        },
        price: {
          free: this.free,
          not_free: this.not_free
        },
        review: this.review,
        course_time: this.course_time
      }
    }

    this.getSearch(this.body);
  }

  clearData(c) {
    // // console.log(c);
    switch (c) {
      case 'type': {
        this.news = false;
        this.artical = false;
        this.course = false;
        this.workshop = false;
        this.measure = false;
        this.research = false;

        this.body = {
          search_text: this.keyword,
          filter: {
            type: {
              news: this.news,
              artical: this.artical,
              course: this.course,
              workshop: this.workshop,
              measure: this.measure,
              research: this.research,
            },
            price: {
              free: this.free,
              not_free: this.not_free
            },
            review: this.review,
            course_time: this.course_time
          }
        }
        break;
      }

      case 'price': {
        this.free = false;
        this.not_free = false

        this.body = {
          search_text: this.keyword,
          filter: {
            type: {
              news: this.news,
              artical: this.artical,
              course: this.course,
              workshop: this.workshop,
              measure: this.measure,
              research: this.research,
            },
            price: {
              free: this.free,
              not_free: this.not_free
            },
            review: this.review,
            course_time: this.course_time
          }
        }
        break;
      }

      case 'review': {
        this.review = '';

        this.body = {
          search_text: this.keyword,
          filter: {
            type: {
              news: this.news,
              artical: this.artical,
              course: this.course,
              workshop: this.workshop,
              measure: this.measure,
              research: this.research,
            },
            price: {
              free: this.free,
              not_free: this.not_free
            },
            review: this.review,
            course_time: this.course_time
          }
        }
        break;
      }

      case 'video': {
        this.course_time = ''
        this.body = {
          search_text: this.keyword,
          filter: {
            type: {
              news: this.news,
              artical: this.artical,
              course: this.course,
              workshop: this.workshop,
              measure: this.measure,
              research: this.research,
            },
            price: {
              free: this.free,
              not_free: this.not_free
            },
            review: this.review,
            course_time: this.course_time
          }
        }
        break;
      }
    }
    this.getSearch(this.body);
  }

  getSearch(body) {

    this.searchService.getSearch(body).pipe(
      map(res => {
        if (res.success) {
          // // console.log(res.result);
          this.newsList = res.result[0].news;
          this.articalList = res.result[1].artical;
          this.courseList = res.result[2].course;
          this.workshopList = res.result[3].workshop;
          this.measureList = res.result[4].measure;
          this.researchList = res.result[5].research;

          this.manageData();
          this.sortData();

          const queryParams: Params = { keyword: this.keyword };
          this.router.navigate(
            ['/search'],
            {
              relativeTo: this.route,
              queryParams: queryParams,
              queryParamsHandling: 'merge',
            });

        }
        else {
          alert('ดึงข้อมูลไม่สำเร็จ');
        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();
  }

  manageData() {

    this.newsListDisplay = this.newsList.map(el => {
      return {
        id: el.NEWS_ID,
        title: el.NEWS_TITAL,
        detail: el.NEWS_DETAIL.replace(/<\/?[^>]+(>|$)/g, ""),
        date: el.NEWS_DATE,
        pic: el.NEWS_PIC,
        type: 'ข่าว',
        price: 0
      }
    });

    this.articalListDisplay = this.articalList.map(el => {
      return {
        id: el.ARTICAL_ID,
        title: el.ARTICAL_TITAL,
        detail: el.ARTICAL_DETAIL.replace(/<\/?[^>]+(>|$)/g, ""),
        date: el.ARTICAL_DATE,
        pic: el.ARTICAL_PIC,
        type: 'บทความ',
        price: 0
      }
    });

    this.courseListDisplay = this.courseList.map(el => {
      return {
        id: el.COURSE_ID,
        title: el.COURSE_NAME,
        pic: el.COURSE_PIC,
        type: 'คอร์สเรียน',
        avgPoint: el.AVG_POINT,
        dulation: el.DULATION,
        countLesson: el.COUNT_LESSON,
        countVideo: el.COUNT_VDO,
        username: el.USERNAME,
        price: el.COURSE_PRICE,
        date: el.COURSE_START,
        countReview: el.COUNT_REVIEW,
        isPremium: el.IS_PREMIUM,
        premiumPrice: el.COURSE_SPECIALPRICE
      }
    });

    this.workshopListDisplay = this.workshopList.map(el => {
      return {
        id: el.WORKSHOP_ID,
        title: el.WORKSHOP_NAME,
        pic: el.WORKSHOP_PIC,
        type: 'กิจกรรม',
        date: el.WORKSHOP_DATE,
        username: el.WORKSHOP_COACH,
        price: el.WORKSHOP_PRICE,
        coachPic: el.WORKSHOP_COACH_PIC
      }
    });

    this.measureListDisplay = this.measureList.map(el => {
      return {
        id: el.MEASURE_ID,
        title: el.MEASURE_NAME,
        pic: el.IMAGE_MEASURE,
        type: 'แบบทดสอบ',
        mtype: el.MEASURE_TYPE,
        link: el.LINK,
        price: 0,
        IS_MULTI_INFORMANT: el.IS_MULTI_INFORMANT,
      }
    });

    this.researchListDisplay = this.researchList.map(el => {
      return {
        id: el.RESEARCH_ID,
        title: el.RESEARCH_NAME,
        pic: el.RESEARCH_IMG,
        type: 'ระบบวิจัย',
        coinShare: el.COIN_SHARE,
        wave: el.PROGRESS.phase,
        measure: el.PROGRESS.sum_measureOfResearch,
        price: 0
      }
    });
  }

  sortData() {

    this.select = this.sortForm.value.sort
    // // console.log(this.select);

    switch (this.select) {

      case '': {
        this.display = [...this.newsListDisplay, ...this.articalListDisplay, ...this.courseListDisplay, ...this.workshopListDisplay, ...this.measureListDisplay, ...this.researchListDisplay];
        // // console.log(this.display);
        break;
      }

      case 'new': {
        let displaytime = [...this.newsListDisplay, ...this.articalListDisplay, ...this.courseListDisplay, ...this.workshopListDisplay, ...this.measureListDisplay, ...this.researchListDisplay];
        // // console.log(this.display);
        this.display = _.sortBy(displaytime, [function (d) { return d.date; }]).reverse();
        break;
      }

      case 'price_asc': {
        let displayPriceAsc = [...this.newsListDisplay, ...this.articalListDisplay, ...this.measureListDisplay, ...this.researchListDisplay, ...this.courseListDisplay, ...this.workshopListDisplay];
        // // console.log(this.display);
        this.display = _.sortBy(displayPriceAsc, [function (d) { return d.price; }]);
        break;
      }

      case 'price_desc': {
        let displayPriceDesc = [...this.articalListDisplay, ...this.newsListDisplay, ...this.measureListDisplay, ...this.researchListDisplay, ...this.courseListDisplay, ...this.workshopListDisplay];
        // // console.log(this.display);
        this.display = _.sortBy(displayPriceDesc, [function (d) { return d.price; }]).reverse();

        break;
      }
    }
    this.refresh();
  }

  changePage(type, id, link, informant) {
    // // console.log(type, id, link);

    switch (type) {
      case 'ข่าว': {
        this.router.navigate(['/news/' + id]);
        break;
      }
      case 'บทความ': {
        this.router.navigate(['/article/' + id]);
        break;
      }
      case 'คอร์สเรียน': {
        this.router.navigate(['/e-learning/' + id]);
        break;
      }
      case 'กิจกรรม': {
        this.router.navigate(['/activity/workshop/' + id]);
        break;
      }
      case 'แบบทดสอบ': {
        if (informant === 0) {
          this.router.navigate(['/measure/' + link]);
        } else {
          this.router.navigate(['/measure/' + link],
            { queryParams: { IS_MULTI_INFORMANT: 1 } });
        }
        break;
      }
      case 'ระบบวิจัย': {
        this.router.navigate(['/research/research-consent'],
        { queryParams: { research_id: id } });
        break;
      }
    }
  }

  refresh() {
    this.collectionSize = this.display.length;
    this.rows = this.display
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

}
